export default __webpack_public_path__ + "static/media/Bhojtal.3940f805.jpg";